import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map,  catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AppState } from '../app.reducer';
import { SetUserAction, UnsetUserAction } from './auth.actions';
import { Subscription, of, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ActivarLoadingAction, DesactivarLoadingAction } from '../shared/reducers/ui.accions';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class AuthService {

	userAuth;
	emailAuthProvider;
	userState: Observable<any>;
	apiUrl = environment.apiUrl;
	apiBaseUrl = environment.apiBaseUrl;

	private userSubscription: Subscription = new Subscription();
	private usuario;

	constructor(
		private router: Router,
		private store: Store<AppState>,
		private http: HttpClient
	) {
		this.checkAuth();
	}
	private getHeaders() {
		return new HttpHeaders({
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		});

	}


	initAuthListener() {
			this.checkAuth().subscribe(isAuthenticated => {
				if (!isAuthenticated) {
					this.usuario = null;
					this.store.dispatch(new UnsetUserAction());
					this.userSubscription.unsubscribe();
				}
			});

	}

	private checkAuth(): Observable<boolean> {
		return this.http.get(`${this.apiUrl}/user`, {
			headers: this.getHeaders(),
			withCredentials: true
		}).pipe(
			map((user: any) => {
				// console.log('user', user);
				this.store.dispatch(new SetUserAction(user));
				this.usuario = user;
				return user;
			}),
			catchError(() => {
				this.store.dispatch(new UnsetUserAction());
				return of(null);
			})
		);

	}


	crearUsuario(user: any, password: string, formOrder?: boolean) {

			// console.log('user', user);
			this.http.post(`${environment.apiUrl}/register`, {
				email: user.email,
				password: password,
				phone: user.telefono,
				city: user.ciudad,
				name: user.nombre
			}).subscribe({
				next: () => {
					this.login(user.email, password);
					this.router.navigate(['/']);
					this.store.dispatch(new DesactivarLoadingAction());

				},
				error: (error: any) => {
					console.log('error', error);
					if (error.error.errors) {
						const errorMessages = Object.values(error.error.errors).flat().join('<br>');
						Swal.fire('Error', errorMessages, 'error');
					} else {
						Swal.fire('Error', 'Error al crear el usuario', 'error');
					}
				}
			});



	}






	editPassword(uid: string, password: string) {
			return this.http.post(`${environment.apiUrl}/updatePassword`, { password });

	}




	login(email: string, password: string, cargando?: boolean) {

			if (cargando) {
				this.store.dispatch(new ActivarLoadingAction());
			}

			this.http.get(`${environment.apiBaseUrl}/sanctum/csrf-cookie`, {
				withCredentials: true
			}).subscribe({
				next: () => {
					this.http.post(`${environment.apiUrl}/login`, {
						email,
						password
					}, {
						headers: this.getHeaders(),
						withCredentials: true
					}).subscribe({
						next: () => {
							this.checkAuth().subscribe(() => {
								if (cargando) {
									this.store.dispatch(new DesactivarLoadingAction());
								}
								const address = localStorage.getItem('address');
								if (address) {
									this.router.navigate(['/comercios']);
								} else {
									this.router.navigate(['/']);
								}
							});
						},
						error: (error) => {
							if (cargando) {
								this.store.dispatch(new DesactivarLoadingAction());
							}
							const attempts = parseInt(localStorage.getItem('attempts') || '0', 10) + 1;
							localStorage.setItem('attempts', attempts.toString());
							if (attempts > 1) {
								Swal.fire(
									{
										title: '',
										text: 'Para seguir mejorando la seguridad de tu cuenta, hemos realizado actualizaciones en nuestro sistema. Por favor, recupera tu contraseña para continuar utilizando la aplicación.',
										icon: 'info',
										footer: '<a class="btn btn-primary" href="' + environment.apiBaseUrl + '/password/reset">Recuperar contraseña</a>',
										showConfirmButton: false
									}
								);
								localStorage.removeItem('attempts');
							} else {
								Swal.fire('Error', error.error.message, 'error');
							}
						}
					});
				},
				error: () => {
					if (cargando) {
						this.store.dispatch(new DesactivarLoadingAction());
					}
					Swal.fire('Error', 'No se pudo obtener el token CSRF', 'error');
				}
			});


	}




	logout() {
			this.http.post(`${environment.apiUrl}/logout`, {}, {
				headers: this.getHeaders(),
				withCredentials: true
			}).subscribe(() => {

				this.store.dispatch(new UnsetUserAction());
				window.location.href = "/"
			});

	}


	isAuth() {
			return this.checkAuth();

	}



	getUsuario() {
		return { ...this.usuario };
	}

	getOrderByClient(uid) {

			return this.http.get(`${environment.apiUrl}/orders`).pipe(
				map((orders: any) => orders)
			);

	}


}
